import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { TranslationKey } from '../i18n/translationKeys';

export const NotFound: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="p-xl flex flex-col items-center gap-l">
            <h1 data-testid="not-found-heading">404</h1>
            <p className="text-primary-1100" data-testid="not-found-message">{t(TranslationKey.NotFound.Message)}</p>
            <Link
                to="/"
                className="text-primary-700 underline hover:text-primary-1100"
                data-testid="not-found-home-link"
            >
                {t(TranslationKey.NotFound.BackHome)}
            </Link>
        </div>
    );
};
